<template>
	<DashboardCard :heading="title" icon="folder_check_2">
		<div v-if="offer === undefined">
			<DashboardMetric
				class="col-span-3"
				:label="messages.labels.description"
				:value="description"
			/>
		</div>

		<div v-else class="grid grid-cols-3 gap-y-6">
			<DashboardMetric
				class="col-span-3"
				:label="messages.labels.description"
				:value="description"
			/>
			<DashboardMetric
				class="col-span-1"
				:label="messages.labels.acceptanceDate"
				:value="formatOfferDate(offer.acceptanceDate)"
			/>
			<DashboardMetric
				class="col-span-1"
				:label="messages.labels.passingDate"
				:value="formatOfferDate(offer.passingDate)"
			/>
			<DashboardMetric
				:label="messages.labels.signature"
				:value="offer.mustReturnSignedCopy ? 'Ja' : 'Nee'"
			/>

			<div class="col-span-3">
				<p class="pb-2 text-sm text-text-secondary">
					{{ messages.labels.documents }}
				</p>
				<div class="grid grid-cols-1 gap-3">
					<DashboardMetricWithIcon
						v-for="document in offerDocuments"
						:key="document.docSoort"
						icon="description"
						:value="splitHdnValue(document.docSoort)[1]"
						:link-to="{ name: 'LoanOffersPage' }"
					/>
				</div>
			</div>
		</div>
	</DashboardCard>
</template>

<script lang="ts" setup>
import { useQuery } from "@/composables/useZero";
import { queries } from "@loanlink-nl/zero";
import { computed } from "vue";
import { splitHdnValue } from "@/helpers/hdnHelpers";

const props = defineProps<{
	applicationId: string;
}>();

const messages = {
	labels: {
		description: "Beschrijving",
		acceptanceDate: "Acceptatiedatum",
		passingDate: "Passeerdatum",
		signature: "Handtekening nodig?",
		documents: "Documenten",
	},
	heading: {
		unknown: "Offerte",
		final: "Definitieve offerte",
		preliminary: "Renteaanbod",
	},
	description: {
		final: "De definitieve offerte moet getekend worden om verder te gaan.",
		unknown: "Nog geen offertes ontvangen.",
		preliminary: "Het voorlopige renteaanbod.",
	},
};

const { data: offer } = useQuery(() =>
	queries.loanOffers.latestForApplication({
		loanApplicationId: props.applicationId,
	}),
);

const offerDocuments = computed(() => offer.value?.documents ?? []);

function formatOfferDate(date: number | null | undefined): string | null {
	if (date === null || date === undefined) {
		return null;
	}
	return new Date(date).toLocaleDateString("nl-NL");
}

const title = computed(() => {
	if (offer.value === undefined) {
		return messages.heading.unknown;
	}
	return offer.value.type === "final"
		? messages.heading.final
		: messages.heading.preliminary;
});

const description = computed(() => {
	if (offer.value === undefined) {
		return messages.description.unknown;
	}
	return offer.value.type === "final"
		? messages.description.final
		: messages.description.preliminary;
});
</script>
